import { languageCodes, PROJECT } from "../config";
import I18n from "i18n";
export const getBuildings = (district, collection) => {
  // console.info('object', district, collection)
  let buildings = collection[0].buildings;
  let result = collection.filter((obj) => {
    return obj.value === district;
  });

  if (result[0] && district !== -1) {
    buildings = buildings.concat(result[0].buildings);
  }

  return buildings;
};
export const getActivityGroupByLanguage = (language, activityGroups) => {
  // return activityGroups[language];
  const allActivityGroups = activityGroups[language];
  if (allActivityGroups !== undefined) {
    return allActivityGroups;
  } else {
    return activityGroups[languageCodes.english];
  }
};

export const getJobFamiliesByLanguage = (language, jobFamilies) => {
  const allJobFamilies = jobFamilies[language];
  if (allJobFamilies !== undefined) {
    return allJobFamilies;
  } else {
    return jobFamilies[languageCodes.english];
  }
};

export const getExceptionsByLanguage = (language, exceptions) => {
  // return exceptions[language];

  const allExceptions = exceptions[language];
  if (allExceptions !== undefined) {
    return allExceptions;
  } else {
    return exceptions[languageCodes.english];
  }
};
export const getProjectsByActivityGroup = (
  querySnapshot,
  activityGroup,
  defaultActivity,
  defaultProject,
  defaultLeave,
  jobRole, 
  district
) => {
  let project = [];
  let disrestrictedProject = [];
   //console.log("querySnapshot",JSON.stringify(querySnapshot))
  if (
    querySnapshot != null &&
    querySnapshot[activityGroup] != undefined &&
    querySnapshot[activityGroup] != null
  ) {
    let activityGrpDetails = querySnapshot[activityGroup];
    if (jobRole && jobRole != -1) {
      activityGrpDetails = activityGrpDetails.filter((record) => {
        return (
          !record.isJobRoleRestricted ||
          record.isJobRoleRestricted === false ||
          (record.jobRoles &&
            record.isJobRoleRestricted === true &&
            record.jobRoles.includes(jobRole))
        );
      });
    }
      //console.log("activityGrpDetails-",activityGrpDetails);
    activityGrpDetails.forEach((doc) => {
      //project.push({ label: doc.name, value: doc.name });

      if (doc.isDistrictRestricted && district && district !== '') {
        if (doc.restrictedDistricts && doc.restrictedDistricts.includes(district)) {
          disrestrictedProject.push({
            label: doc.name,
            value: doc.name,
            parent: I18n.t("other.lblDistricts"),
            
          });
        }
      } else {
          project.push({
              label: doc.name,
              value: doc.name,
              parent: I18n.t("other.lblAll"),
             
          });
      }
    });

  }
      
  disrestrictedProject = disrestrictedProject.sort((a, b) =>
    a.label.toLowerCase().localeCompare(b.label.toLowerCase())
  );
  project = project.sort((a, b) =>
    a.label.toLowerCase().localeCompare(b.label.toLowerCase())
  );

  

  project = [...disrestrictedProject,...project];
  
  if (activityGroup == PROJECT) {
    project = defaultProject.concat(project);
  } else if (activityGroup == "Leave") {
    project = defaultLeave.concat(project);
  } else {
    project = defaultActivity.concat(project);
  }
  return project;
};

export const getPunch = (
  activityGroup,
  activityName,
  buildingId,
  districtId,
  customerSite,
  exceptionName,
  isException,
  jobName,
  jobProjectInfo,
  status,
  version,
  workerId,
  actionTS,
  inTS,
  inLocalTS,
  outTS,
  outLocalTS,
  actionBy,
  deviceDetails,
  category,
  projectDetails
) => {
  let projectInfoDetails = projectDetails?projectDetails:"";
  let punch = {
    activityGroup: activityGroup,
    activityName: activityName, //  in/out/transfer
    buildingId: buildingId, // user entered building id
    districtId: districtId, // user entered district id
    customerSite: customerSite,
    exceptionName: exceptionName, // need to ask
    isException: isException, // need to ask
    jobName: jobName, // need to ask job family name
    jobProjectInfo: jobProjectInfo, // project name or imaging details
    status: status, // new or approved or deleted  always new for mobile
    version: version, // need to ask  // send unique value
    workerId: workerId, // logged in use workerId
    actionTS: actionTS, // store user action time stamp
    inTS: inTS,
    inLocalTS: inLocalTS,
    outTS: outTS,
    outLocalTS: outLocalTS,
    actionBy: actionBy, // ID of supervisor in case of add or edit of punch
    deviceDetails: deviceDetails,
    category: category,
    projectDetails: projectInfoDetails,
  };

  return punch;
};

export const getUniqueID = () => {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return "_" + Math.random().toString(36).substr(2, 9);
};

export const getJobProjectInfo = (specialProject) => {
  let jobProjectInfo = "";
  if (specialProject.length > 0) {
    jobProjectInfo = specialProject;
  }

  return jobProjectInfo;
};

export const getCustomerSite = (customerSite) => {
  let customerSiteVal = "";
  if (customerSite.length > 0) {
    customerSiteVal = customerSite;
  }
  return customerSiteVal.trim();
};

export const getActivityDetails = (Options, activity) => {
  let activityDetails = Options.filter((item) => item.value === activity);
  let isPersist = false;
  if (
    activityDetails.length > 0 &&
    typeof activityDetails[0].isPersist !== "undefined"
  ) {
    isPersist = activityDetails[0].isPersist;
  }
  return isPersist;
};

export const getHoursFormat = (hours) => {
  const hourArray = hours.toFixed(2).toString().split(".");
  if (hourArray[0].length === 1) {
    hourArray[0] = "0" + hourArray[0];
  }
  const formattedHours = hourArray.join(".");
  return formattedHours;
};
